
import { WorldCountry } from '../types';
import { belgiumExpanded } from './belgiumExpansion';

export const finalEuropeCountries10: WorldCountry[] = [
  belgiumExpanded
];
